import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import onClickOutside from 'react-onclickoutside';

import { input } from '../../../../../../commonStyles.js';
import styles from '../styles.js';

import Translatable, { Translate } from '../../../../../../components/Translatable';

class DateInput extends Component {
    static propTypes = {
        closePanel: PropTypes.func,
        date: PropTypes.string,
        dateInput: PropTypes.object.isRequired,
        idSuffix: PropTypes.string.isRequired,
        isMobile: PropTypes.bool.isRequired,
        onHideDateInput: PropTypes.func.isRequired,
        onShowDateInput: PropTypes.func.isRequired,
        userLang: PropTypes.string
    }

    static defaultProps = {
        isMobile: false
    }

    state = {
        hasChanged: false,
        isOpen: false
    }

    componentDidMount() {
        const {
            idSuffix,
            isMobile,
            userLang
        } = this.props;
        setTimeout(() => {
            this._datePicker = $(`#date_SearchBar${idSuffix}`);
            if (isMobile) {
                this._datePicker.datepicker({
                    dateFormat: 'dd-mm-yy'
                });
            } else {
                this._datePicker.datepicker({
                    beforeShow: () => {
                        this.setState({
                            isOpen: true
                        });
                    },
                    dateFormat: 'dd-mm-yy',
                    onClose: () => {
                        this.setState({
                            isOpen: false
                        });
                    },
                    onSelect: () => {
                        this.setState({
                            hasChanged: true
                        });
                    }
                });
            }
            $.datepicker.setDefaults($.datepicker.regional[userLang]);
            const formattedDate = new Date(this.props.date);
            this._datePicker.datepicker('setDate', formattedDate);
        }, 150);
    }

    handleClickOutside = () => {
        setTimeout(() => {
            if (!this.state.isOpen) {
                const date = this._datePicker.datepicker('getDate');
                const formattedDate = $.datepicker.formatDate('dd-mm-yy', date);
                this.props.onHideDateInput(formattedDate);
                if (this.props.closePanel) {
                    this.props.closePanel();
                }
            }
        }, 150);
    }

    handleShowDateInput = () => {
        this.props.onShowDateInput();
    }

    render() {
        return (
            <div>
                <label
                    className={css(styles.hiddenLabel)}
                    htmlFor={`autocomplete_SearchBar${this.props.idSuffix}`}
                >
                    <Translatable
                        content={{
                            transKey: 'common.when'
                        }}
                    />
                </label>
                <div className={css(styles.container, styles.container_noMargins)}>
                    <div
                        style={{
                            display: 'table'
                        }}
                    >
                        <div
                            style={{
                                display: 'table-cell',
                                verticalAlign: 'middle'
                            }}
                        >
                            <div className={css(styles.prefixContainer)}>
                                <div className={css(styles.prefix)}>
                                    <div>
                                        <svg
                                            viewBox="0 0 24 24"
                                            role="presentation"
                                            aria-hidden="true"
                                            focusable="false"
                                            style={{
                                                display: 'block',
                                                fill: 'currentColor',
                                                height: '18px',
                                                width: '18px'
                                            }}
                                        >
                                            <path
                                                d="M22 9.5V3h-4.75V1a.75.75 0 1 0-1.5 0v2H8.249l.001-2a.75.75 0 1 0-1.5 0l-.001 2H2v19.008a1 1 0 0 0 .992.992h18.016a1 1 0 0 0 .992-.992V9.5zm-18.5-5h3.248V5a.75.75 0 0 0 1.5 0v-.5h7.502V5a.75.75 0 0 0 1.5 0v-.5h3.25V8h-17V4.5zm0 17v-12h17v12h-17z"
                                                fillRule="evenodd"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'table-cell',
                                verticalAlign: 'middle'
                            }}
                        >
                            <Translatable
                                attributes={{
                                    placeholder: {
                                        transKey: 'common.when'
                                    }
                                }}
                            >
                                <input
                                    type="text"
                                    autoComplete="off"
                                    className={css(styles.input)}
                                    id={`date_SearchBar${this.props.idSuffix}`}
                                    name="date"
                                    defaultValue={this.props.dateInput.value}
                                    onClick={this.handleShowDateInput}
                                />
                            </Translatable>
                        </div>
                    </div>
                </div>
                <div
                    className={
                        this.props.dateInput.visible ?
                            css(input.focusUnderline, styles.showUnderline) :
                            css(input.focusUnderline)
                    }
                />
            </div>
        );
    }
}

export default onClickOutside(DateInput);



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarLarge/DateInput/DateInput.jsx